export const LOAD_ALL_CONTACTS = 'LOAD_ALL_CONTACTS'
export const LOAD_ALL_CUSTOMER = 'LOAD_ALL_CUSTOMER'
export const LOAD_CONTACTS = 'LOAD_CONTACTS'
export const ADD_CONTACT = 'ADD_CONTACT'
export const UPDATE_CONTACT = 'UPDATE_CONTACT'
export const ADD_NEXT_CONTACTS = 'ADD_NEXT_CONTACTS'
export const ADD_CONTACTS_META = 'ADD_CONTACTS_META'
export const SET_AVATAR = 'SET_AVATAR'
export const DELETE_CONTACT = 'DELETE_CONTACT'